import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of, switchMap } from 'rxjs';
import { SessionService } from '@auth/auth';
import { EventType } from './event-type';
import { BrowserUtils } from '../utils/browser-utils';
import { ShellLoggingService } from '../services/shell-logging/shell-logging.service';

@Injectable()
export class LoginGuard {
  constructor(
    private sessionService: SessionService,
    private shellLoggingService: ShellLoggingService,
    private router: Router
  ) {}

  private handleNotAuthenticated(): Observable<boolean> {
    // We need to remove the trailing slash because routes of some MFE aren't able to handle it (like in Analytics)
    const path = window.location.pathname.replace(/\/$/, '') || '/';

    if (path.includes('session/')) {
      // This is to avoid infinite loop.
      return of(true);
    } else {
      this.sessionService.login({
        appState: {
          target: path + window.location.search
        }
      });
      return of(false);
    }
  }

  private handleAuthenticated(): Observable<boolean> {
    const eventType = EventType.Successful_Login;
    const currentPath = window.location.pathname;
    this.shellLoggingService
      .log(
        eventType,
        'AuthService: Successful login',
        BrowserUtils.getBrowserInfo()
      )
      .subscribe({
        next: (authUser) => {
          if (eventType === EventType.Successful_Login) {
            this.shellLoggingService.changeShellUser(authUser.userAttributes);
          }
        },
        error: () => {
          this.router.navigateByUrl(`${currentPath}/session/error`);
        }
      });
    return of(true);
  }

  canActivate(): Observable<boolean> | boolean {
    return this.sessionService.isAuthenticated$.pipe(
      switchMap((isAuthenticated: boolean) => {
        if (isAuthenticated) {
          return this.handleAuthenticated();
        } else {
          return this.handleNotAuthenticated();
        }
      })
    );
  }
}
